import { render, staticRenderFns } from "./crm-pagination.vue?vue&type=template&id=f825cee2&"
import script from "./crm-pagination.vue?vue&type=script&lang=js&"
export * from "./crm-pagination.vue?vue&type=script&lang=js&"
import style0 from "./crm-pagination.vue?vue&type=style&index=0&id=f825cee2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports